import gql from "graphql-tag";

export const SEND_REPORT_MUTATION = gql`
  mutation SendReport(
    $reportSecret: String!
    $language: CharacteristicLanguage!
    $sheetIds: [String!]
    $layout: PdfLayout!
    $recipientEmail: String!
    $settings: PrintPdfSettingsInput!
  ) {
    sendReport(
      reportSecret: $reportSecret
      language: $language
      sheetIds: $sheetIds
      layout: $layout
      recipientEmail: $recipientEmail
      settings: $settings
    )
  }
`;
